import { useNavigate } from 'react-router-dom'
import { Finder } from '../components/Finder'
import { useTranslation } from '../localization/useTranslation'
import { useSetPageTitle } from '../store/pageTitle'

/**
 * "Add manually" page (route `/add`) — the finder for items the order-feed customer bought
 * elsewhere. A real route (not an ItemsPage sub-view) so entering it scrolls to the top and gets its
 * own history entry, instead of leaving the customer scrolled deep in a long order grid. The finder
 * back arrow returns to the order grid on `/items`.
 */
export function AddManuallyPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  useSetPageTitle(t('items.manualTitle'), t('items.manualSubtitle'))
  return (
    <div className="step">
      <Finder onBack={() => navigate('/items')} />
    </div>
  )
}
